module.exports = __webpack_public_path__ + "static/media/HexagonFrame.c293bc55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Introduction/Assets/HexagonFrame.svg
// module id = 504
// module chunks = 1